import { createPortal } from 'react-dom';
import { UniversalSpinner } from '../../components/universal-spinner/universal-spinner';
import { useGlobalNotificationLogic } from './global-notification.hooks';
import {
  Overlay,
  LoadingContainer,
  LoadingText,
  ErrorContainer,
  ErrorText,
  SuccessContainer,
  SuccessText,
} from './global-notification.styled';

export const GlobalNotification = () => {
  const { notification, shouldRender, handleClick } = useGlobalNotificationLogic();

  if (!shouldRender) {
    return null;
  }

  return createPortal(
    <Overlay onClick={handleClick}>
      {notification.type === 'loading' && (
        <LoadingContainer>
          <UniversalSpinner />
          <LoadingText>{notification.message || 'Preparing your data'}</LoadingText>
        </LoadingContainer>
      )}

      {notification.type === 'error' && (
        <ErrorContainer>
          <ErrorText>{notification.message}</ErrorText>
        </ErrorContainer>
      )}

      {notification.type === 'success' && (
        <SuccessContainer>
          <SuccessText>{notification.message}</SuccessText>
        </SuccessContainer>
      )}
    </Overlay>,
    document.body
  );
};
